import React from "react";
import { Tooltip } from "antd";
import { FileTextOutlined } from "@ant-design/icons"; // Use Ant icons for simplicity

const FileButton = ({
  fileUrl,
  isSelected,
  compareMode,
  type,
  onSelect,
  onPreview,
}) => {
  const isDocx = fileUrl?.toLowerCase().endsWith(".docx");
  const isPdf = fileUrl?.toLowerCase().endsWith(".pdf");
  const isAvailable = !!fileUrl;
  const isDisabled = compareMode && (!isAvailable || !isDocx);

  // === Decide icon color ===
  let iconColor = "#ccc"; // gray default
  if (!compareMode) {
    iconColor = isAvailable ? "#36A34A"  : "#ccc"; // light green if file available
  } else {
    if (isSelected) iconColor = "#135200"; // dark green if selected
    else if (isAvailable && isDocx) iconColor = "#4E36A3"; // violet if selectable
    else iconColor = "#ccc"; // gray if missing or invalid
  }

  const tooltipTitle = !compareMode
    ? isAvailable
      ? "Preview File"
      : "File not available"
    : isDocx
    ? `Click to select as ${type}`
    : "Not a DOCX file";

  // === Click Logic ===
  const handleClick = () => {
    if (isDisabled) return;
    if (!compareMode && isAvailable) {
      onPreview(fileUrl);
    } else if (compareMode && isDocx) {
      onSelect(fileUrl);
    }
  };

  return (
    <Tooltip title={tooltipTitle}>
      <button
        type="button"
        aria-label={tooltipTitle}
        disabled={isDisabled}
        onClick={handleClick}
        style={{
          background: "transparent",
          border: "none",
          outline: "none",
          cursor: isDisabled ? "not-allowed" : "pointer",
          transform: "scale(1)",
          transition: "transform 0.2s ease, color 0.3s ease",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
        onMouseEnter={(e) => {
          if (!isDisabled)
            e.currentTarget.style.transform = "scale(1.15)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "scale(1)";
        }}
      >
        <FileTextOutlined
          style={{
            fontSize: 22,
            color: iconColor,
          }}
        />
      </button>
    </Tooltip>
  );
};

export default FileButton;
